import api from './api';
import API_CONFIG from '../config/api.config';

const veiculoService = {
  // Listar todos os veículos
  async listarTodos() {
    try {
      const response = await api.get(API_CONFIG.ENDPOINTS.VEICULOS.LISTAR_TODOS);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cadastrar um novo veículo
  async cadastrar(veiculoData) {
    try {
      const response = await api.post(API_CONFIG.ENDPOINTS.VEICULOS.CADASTRAR, veiculoData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Listar veículos por prefeitura
  async listarPorPrefeitura(idPrefeitura) {
    try {
      const response = await api.get(API_CONFIG.ENDPOINTS.VEICULOS.VEICULO_PREFEITURA(idPrefeitura));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Buscar um veículo específico
  async buscarVeiculo(id) {
    try {
      const response = await api.get(API_CONFIG.ENDPOINTS.VEICULOS.VEICULO_ESPECIFICO(id));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Atualizar um veículo
  async atualizar(id, veiculoData) {
    try {
      const response = await api.put(API_CONFIG.ENDPOINTS.VEICULOS.ATUALIZAR(id), veiculoData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default veiculoService; 